// extracted by mini-css-extract-plugin
export var container = "_ua-0";
export var table = "_ua-2";
export var tableWrapper = "_ua-1";